import { startRegistration } from '@simplewebauthn/browser';
import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import type {
  Passkey,
  PasskeyDeleteInput,
  PasskeyRegisterInput,
} from '@/Domain/api/User/dto/Passkey.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class PasskeyApi {
  static list = (): Promise<Passkey[]> =>
    httpClient.get(Endpoint.user.passkeys).then(ApiMapper.toResponseData);

  static register = async ({ currentPassword }: PasskeyRegisterInput): Promise<Passkey> => {
    const optionsJSON = await httpClient
      .post(Endpoint.user.passkeyRegistrationOptions, { current_password: currentPassword ?? null })
      .then(ApiMapper.toResponseData);
    const credential = await startRegistration({ optionsJSON });
    return httpClient
      .post(Endpoint.user.passkeyRegistrationVerify, { credential })
      .then(ApiMapper.toResponseData);
  };

  static remove = async ({ passkeyId, currentPassword }: PasskeyDeleteInput): Promise<void> => {
    await httpClient.delete(Endpoint.user.passkey.replace(':passkeyId', String(passkeyId)), {
      data: { current_password: currentPassword ?? null },
    });
  };
}
